import {Project} from "../api/Project";

export const docuConverterProject: Project = {
    id: 4,
    title: 'DocuConverter',
    description: 'An API and library that converts documents from one format to another, say DOCX to PDF or PPT to PDF',
    link: 'https://github.com/chirag-ji/DocuConverter',
    image: 'https://github.githubassets.com/pinned-octocat.svg',
    startDate: 'July 2019',
    completeDate: 'July 2019',
    hidden: false,
    technologies: {
        frontend: undefined,
        backend: [
            "Core Java",
            "Apache POI"
        ]
    },
};
